import { makeStyles } from '@mui/styles';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const useStyles = makeStyles((theme: any) => ({
  helperIconRoot: {
    marginLeft: theme.spacing(1)
  }
}));
